import { BaseButton, type BaseButtonProps } from '@/components/common/base-button';
import styles from './styles.module.scss';
import clsx from 'clsx';

interface ShopFnbFacilityBuildingOptionButtonProps extends BaseButtonProps {
    title: string;
    onClick: () => void;
}

const ShopFnbFacilityBuildingOptionButton = ({ title, onClick, ...props }: ShopFnbFacilityBuildingOptionButtonProps) => {
    return (
        <BaseButton
            className={clsx(styles['option-button'], {
                [styles['option-button--active']]: props['aria-checked'],
            })}
            onClick={onClick}
            {...props}
        >
            <span>{title}</span>
        </BaseButton>
    );
};

export default ShopFnbFacilityBuildingOptionButton;
